module.exports = __webpack_public_path__ + "img/馆务公开.4392c6a5.png";